// extracted by mini-css-extract-plugin
export default {"root":"GJN4sdCghG","root_large":"HAAp3enYjV"};